<ng-container *ngIf="user">
  <app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>
</ng-container>
<!-- Visualizzazione in caso di dispositivo mobile-->
<ng-container *ngIf="isMobile ; else isDesktop">
  <!-- nella visualizzazione da mobile facciamo come prima cosa scegliere il paziente
   con cui messaggiare (funzionalità contenuta nel prossimo div).-->
  <div *ngIf="patientChat===null || patientChat===undefined" class="last-chat-containerMobile">
    <form class="myform">
      <mat-form-field class="myformfield">
        <mat-label>Cerca un paziente</mat-label>
        <input class="input-patient" type="text" matInput
               [formControl]="myControl"
               [matAutocomplete]="auto">
        <mat-autocomplete class="myautocomplete" #auto="matAutocomplete"
                          [displayWith]="displayFn"
                          (optionSelected)='getOptionStudent($event.option.value.email)'>
          <mat-option class="myoption" *ngFor="let option of filteredOptions|async" [value]="option">
            {{option.name}} {{option.surname}} ({{option.ssn}})
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </form>

    <h5>Oppure cerca tra le seguenti chat</h5>
    <div class="last-chat-box" *ngFor="let val of lastMessages" (click)='getOptionStudent(val.patientEmail)'>
      <div>
        <span class="last-chat-patient"><b>{{val.patientName}} {{val.patientSurname}}</b></span>
        <span class="last-chat-doctor">Dott. {{val.doctorName}} {{val.doctorSurname}}</span>
      </div>
      <div class="last-chat-text-box">
        <!--<span>{{val.text}}</span>-->
        <span id="last-chat-textMobile"> <i *ngIf="val.sender != val.patientEmail">Dott:</i> {{val.text}}</span>
        <span id="notReadMobile" *ngIf="val.read==false && val.sender == val.patientEmail" class="material-icons">
            announcement
        </span>
      </div>
    </div>
  </div>
  <!-- una volta scelta la persona con cui chattare si apre la pagina classica della
   chat con a destra i nostri messaggi e a sinistra quelli degli altri utenti-->
  <div *ngIf="patientChat!==null && patientChat!==undefined">
    <main>
      <div class="chat-header">
        <p id="patientChatLinkMobile" (click)="openPanel()">{{patientChat.name}} {{patientChat.surname}} ({{patientChat.ssn}})</p>
      </div>
      <div  #scrollMe class="chat-box" [scrollTop]="scrollMe.scrollHeight">
        <div *ngFor="let mess of messages">
          <!-- itIsMy utilizzato per riconoscere i messaggi dell'utente loggato -->
          <div *ngIf="itIsMy(mess)" class="chat-r">
            <div class="sp"></div>
            <div class="mess mess-r">
              <span class="descSender">{{mess.nameSender}} {{mess.surnameSender}}</span>
              <!-- Visualizziamo il testo del messaggio, e lo rendiamo cliccabile nel caso sia un file -->
              <div *ngIf="mess.fileIsPresent == true" class="file" (click)="downloadFile(mess)"><p>{{mess.text}}</p></div>
              <p *ngIf="mess.fileIsPresent == false">{{mess.text}}</p>
              <div class="check">
                <span *ngIf="messages!=undefined">{{mess.date.split("T")[0].split("-")[2]}}/{{mess.date.split("T")[0].split("-")[1]}} &nbsp;&nbsp;&nbsp; {{mess.date.split("T")[1].split(":")[0]}}:{{mess.date.split("T")[1].split(":")[1]}}</span>
              </div>
            </div>
          </div>
          <div *ngIf="!itIsMy(mess)" class="chat-l">
            <div class="mess">
                <span *ngIf="mess.sender != mess.patientEmail" id="doctorSenderLabelMobile" class="descSender">
                  <i><b>Dott: </b></i>{{mess.nameSender}} {{mess.surnameSender}}
                </span>
              <span class="descSender" *ngIf="mess.sender == mess.patientEmail">
                  {{mess.nameSender}} {{mess.surnameSender}}
                </span>
              <!-- Visualizziamo il testo del messaggio, e lo rendiamo cliccabile nel caso sia un file -->
              <div *ngIf="mess.fileIsPresent == true" class="file" (click)="downloadFile(mess)"><p>{{mess.text}}</p></div>
              <p *ngIf="mess.fileIsPresent == false">{{mess.text}}</p>
              <div class="check">
                <span *ngIf="messages!=undefined">{{mess.date.split("T")[0].split("-")[2]}}/{{mess.date.split("T")[0].split("-")[1]}} &nbsp;&nbsp;&nbsp; {{mess.date.split("T")[1].split(":")[0]}}:{{mess.date.split("T")[1].split(":")[1]}}</span>
              </div>
            </div>
            <div class="sp"></div>
          </div>
        </div>
      </div>
    </main>
    <!-- nel footer inserisco il campo che rimane in basso nella pagina
    che serve per scrivere il messaggio.-->
    <footer>
      <mat-card>
        <mat-grid-list id="inputGridMobile" cols="7" rowHeight="fit">
          <mat-grid-tile [colspan]="5" [rowspan]="1">
            <mat-form-field class="myTextFieldMobile">
              <mat-label>Scrivi qui</mat-label>
              <textarea [(ngModel)]="textSend" matInput></textarea>
            </mat-form-field>
          </mat-grid-tile>
          <!-- Di seguito il bottone per allegare un file e quello per mandare un messaggio-->
          <mat-grid-tile [colspan]="1"  [rowspan]="1">
            <button mat-mini-fab id="attachButtonMobile" color="primary" aria-label="Allega file" (click)="attachFile()">
              <span id="attachIconMobile" class="material-icons">attach_file</span>
            </button>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1"  [rowspan]="1">
            <button mat-mini-fab color="primary" aria-label="Invia il messaggio" [disabled]="textSend === ''" (click)="sendMessage()">
              <span class="material-icons">send</span>
            </button>
          </mat-grid-tile>
        </mat-grid-list>
      </mat-card>
    </footer>
  </div>
</ng-container>
<!-- fine visualizzazione per i mobile, da qui sotto la visualizzazione nel caso si sta
utilizzando uno schermo più grande. Il codice è praticamente identico tranne per delle piccole
modifiche che permettono la visualizzazione su un unica pagina di quello che nel mobile veniva
fatto in due e del dimensionamento diverso di alcuni div -->
<ng-template #isDesktop>
  <div class="last-chat-container">
    <form class="myform">
      <mat-form-field class="myformfield">
      <mat-label>Cerca un paziente</mat-label>
      <input class="input-patient" type="text" matInput
             [formControl]="myControl"
             [matAutocomplete]="auto">
      <mat-autocomplete class="myautocomplete" #auto="matAutocomplete"
            [displayWith]="displayFn"
            (optionSelected)='getOptionStudent($event.option.value.email)'>
        <mat-option class="myoption" *ngFor="let option of filteredOptions|async" [value]="option">
          {{option.name}} {{option.surname}} ({{option.ssn}})
        </mat-option>
      </mat-autocomplete>
      </mat-form-field>
    </form>

    <h5>Oppure cerca tra le seguenti chat</h5>
    <div class="last-chat-box" *ngFor="let val of lastMessages" (click)='getOptionStudent(val.patientEmail)'>
      <div>
        <span class="last-chat-patient"><b>{{val.patientName}} {{val.patientSurname}}</b></span>
        <span class="last-chat-doctor">Dott. {{val.doctorName}} {{val.doctorSurname}}</span>
      </div>
      <div class="last-chat-text-box">
        <!--<span>{{val.text}}</span>-->
        <span id="last-chat-text"> <i *ngIf="val.sender != val.patientEmail">Dott:</i> {{val.text}}</span>
        <span id="notRead" *ngIf="val.read==false && val.sender == val.patientEmail" class="material-icons">
            announcement
        </span>
      </div>
    </div>
  </div>


  <div class="chat-container">
    <div class="pazienteAssente" *ngIf="patientChat== undefined">
      <h2>Scegliere un paziente <br>per iniziare una chat.</h2>
    </div>
    <div *ngIf="patientChat != undefined">
      <main>
        <div class="chat-header">
          <p id="patientChatLink" (click)="openPanel()">{{patientChat.name}} {{patientChat.surname}} ({{patientChat.ssn}})</p>
        </div>
        <div  #scrollMe class="chat-box" [scrollTop]="scrollMe.scrollHeight">
          <div *ngFor="let mess of messages">
            <div *ngIf="itIsMy(mess)" class="chat-r">
              <div class="sp"></div>
              <div class="mess mess-r">
                <span class="descSender">{{mess.nameSender}} {{mess.surnameSender}}</span>
                <!-- Visualizziamo il testo del messaggio, e lo rendiamo cliccabile nel caso sia un file -->
                <div *ngIf="mess.fileIsPresent == true" class="file" (click)="downloadFile(mess)"><p>{{mess.text}}</p></div>
                <p *ngIf="mess.fileIsPresent == false">{{mess.text}}</p>
                <div class="check">
                  <span *ngIf="messages!=undefined">{{mess.date.split("T")[0].split("-")[2]}}/{{mess.date.split("T")[0].split("-")[1]}} &nbsp;&nbsp;&nbsp; {{mess.date.split("T")[1].split(":")[0]}}:{{mess.date.split("T")[1].split(":")[1]}}</span>
                </div>
              </div>
            </div>
            <div *ngIf="!itIsMy(mess)" class="chat-l">
              <div class="mess">
                <span *ngIf="mess.sender != mess.patientEmail" id="doctorSenderLabel" class="descSender">
                  <i><b>Dott: </b></i>{{mess.nameSender}} {{mess.surnameSender}}
                </span>
                <span class="descSender" *ngIf="mess.sender == mess.patientEmail">
                  {{mess.nameSender}} {{mess.surnameSender}}
                </span>
                <!-- Visualizziamo il testo del messaggio, e lo rendiamo cliccabile nel caso sia un file -->
                <div *ngIf="mess.fileIsPresent == true" class="file" (click)="downloadFile(mess)"><p>{{mess.text}}</p></div>
                <p *ngIf="mess.fileIsPresent == false">{{mess.text}}</p>                <div class="check">
                  <span *ngIf="messages!=undefined">{{mess.date.split("T")[0].split("-")[2]}}/{{mess.date.split("T")[0].split("-")[1]}} &nbsp;&nbsp;&nbsp; {{mess.date.split("T")[1].split(":")[0]}}:{{mess.date.split("T")[1].split(":")[1]}}</span>
                </div>
              </div>
              <div class="sp"></div>
            </div>
          </div>
        </div>
      </main>

      <footer>
        <mat-card>
          <mat-grid-list id="inputGrid" cols="9" rowHeight="fit">
            <mat-grid-tile [colspan]="7" [rowspan]="1">
              <mat-form-field class="myTextField">
                <mat-label>Scrivi qui</mat-label>
                <textarea [(ngModel)]="textSend" matInput></textarea>
              </mat-form-field>
            </mat-grid-tile>
            <!-- qui sotto il bottone per allegare un file e quello per mandare un messaggio-->
            <mat-grid-tile [colspan]="1"  [rowspan]="1">
              <button mat-fab id="attachButton" color="primary" aria-label="Allega file" (click)="attachFile()">
                <span class="material-icons">attach_file</span>
              </button>
            </mat-grid-tile>
            <mat-grid-tile [colspan]="1"  [rowspan]="1">
              <button mat-fab id="sendButton" color="primary" aria-label="Invia il messaggio" [disabled]="textSend === ''" (click)="sendMessage()">
                <span class="material-icons" id="iconSend">send</span>
              </button>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </footer>
    </div>
  </div>
</ng-template>
